export class PessoaCompletaModel {

    constructor(
        public cdCentrus?:  number,
        public cdCentrusAlt?:  number,
        public cdCentrusInc?:  number,
        public cdFormaTratamento?:  number,
        public dhAlteracao?: Date,
        public dhInclusao?: Date,
        public dsObs?: string,
        public dsObsInat?: string,
        public enSite?: string,
        public irPessoa?: string,
        public noPessoa?: string,
        public noPessoaSocial?: string,
        public sgPessoa?: string,
        public tpPessoa?:  number,
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/pessoa-completa.model.ts